<template>
<div class="component" v-if="project!=null">
    <div class="columns is-mobile projectTitleArea">
        
        <div class="column is-12 has-text-right-mobile">
            <div class="wwTitle">Projekt "{{project.projectName}}"</div>
        </div>
    </div>

    <div class="columns is-mobile is-multiline ">
        <div class="column is-3-fullhd is-6-widescreen is-6-desktop is-12-mobile is-6-tablet  arealist projectViewArea">
            <transition-group appear name="slidearealist">

                <div v-for="area in areas" :key="area.id" class="columns is-mobile">
                    <div class="column is-6">
                        <div class="button is-fullwidth" @click="selectedArea=area.id" :class="{'is-info':selectedArea==area.id}">{{area.areaname}}</div>
                    </div>

                    <div class="column is-3">
                        <div class="button is-success" @click="openArea(area.id)">Öffnen</div>
                    </div>

                    <div class="column is-3">
                        <div class="button is-danger" @click="deleteArea(area.id)">Löschen</div>
                    </div>
                </div>
            </transition-group>

            </transition>
        </div>
        <div class="column is-6-widescreen is-12-desktop is-12-tablet is-12-mobile arealist projectViewArea" v-if="openAreaComponent">

            <areafiles @close="openAreaComponent=false" :id="openAreaId" />
        </div>
        <div class="column is-6 filelist projectFileArea projectViewArea" v-else>

            <filemap @save="saveAreas" @select="selectArea" :isInEditMode="editAreas" :selectedArea="selectedArea" :existingrectangles="areas" />

        </div>
        <div class="column is-12-desktop is-12-widescreen is-3-fullhd is-12-mobile is-12-tablet projectUserArea" >
            <div class="columns is-mobile is-multiline">
                <div class="wwTitle is-size-3 column is-6-widescreen is-12-desktop is-12-mobile is-12-tablet  has-text-right-widescreen">Benutzer</div>
                <div class="column  is-6-widescreen is-12-desktop is-12-mobile is-12-tablet  has-text-left-widescreen">

                    <div class="button is-size-5 " @click="addNewUser = true">Hinzufügen</div>
                </div>
            </div>
            <table class="table is-fullwidth">
                <tr v-for="user in project['users']">
                    <td>
                        <div>{{user.name}}</div>
                    </td>
                    <td>
                        <div v-if="project.projectManager_id != user.id" class="button is-small is-danger" @click="deleteUser(user.id)">Löschen</div>
                        <div v-else>Besitzer</div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <loadingscreen v-if="isLoading" />

    <newUserModal @refresh="getProjectDetails()" :projectId="projectId" :isActive="addNewUser" @close="closeNewUserModal()" />
    <addFile @refresh="getProjectFiles()" :projectId="projectId" :isActive="addFile" @close="closeNewFIleModal()" />
</div>
</template>

<script>
import newUserModal from '@/components/addUser.vue'
import fileOverview from '@/components/fileOverview.vue'
import addFile from '@/components/addFile.vue'
import filemap from '@/views/filemap.vue'
import areafiles from '@/views/areafiles.vue'

export default {
    name: 'Project',
    props: ["id"],
    components: {
        newUserModal,
        fileOverview,
        addFile,
        areafiles,
        filemap
    },
    mounted: function () {
        this.projectId = this.$route.params.id;
                        this.isLoading = true;

        this.getProjectDetails()
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            projectId: 0,
            project: null,
            files: null,
            addNewUser: false,
            addFile: false,
            areas: [],
            selectedArea: -1,
            editAreas: false,
            openAreaComponent: false,
            openAreaId: -1,
            isLoading: false

        }
    },
    methods: {
        selectArea(id) {
            this.selectedArea = id
        },
        saveAreas(areas) {
            this.isLoading = true;

            for (var indexpos = 0; indexpos < areas.length; indexpos++) {
                var area = areas[indexpos]
                area.projectId = this.projectId
                this.callApi("/projectarea/create", "post", area).then(function (response) {
                    if (indexpos >= areas.length) {
                        this.getProjectDetails();
                    }
                }.bind(this))
            }

            console.log("save areas:" + areas)
        },
        openArea(id) {
            this.openAreaComponent = true;
            this.openAreaId = id;
        },
        deleteArea(areaid) {
            this.isLoading = true;

            let postData = {
                "projectId": this.projectId,
                "id": areaid
            }
            this.callApi("/projectarea/delete", "post", postData).then(function (response) {
                this.getProjectDetails();
            }.bind(this)).catch(function (error) {
                this.isLoading = false;
            })
        },
        getProjectDetails() {
            this.isLoading = true;
            console.log("get details for project " + this.projectId)
            let postData = {
                "projectId": this.projectId
            }
            this.callApi("/project/details", "post", postData).then(function (response) {
                this.project = response.data.project[0]
                this.areas = this.project.areas
                this.isLoading = false;

            }.bind(this)).catch(function (error) {
                this.isLoading = false;
            })
        },
        deleteUser(userId) {
            let postData = {
                "projectId": this.projectId,
                "userId": userId
            }
            this.callApi("/project/removeUser", "post", postData).then(function (response) {
                this.getProjectDetails()
            }.bind(this))
        },
        closeNewUserModal() {
            this.getProjectDetails();
            this.addNewUser = false;
        },
        closeNewFIleModal() {
            this.addFile = false
        },
        getProjectFiles() {
            this.files = null;
            let postData = {
                "projectId": this.projectId,
            }
            this.callApi("/file/all", "post", postData).then(function (response) {
                this.files = response.data.files
            }.bind(this))
        },

        returnToProjectPage() {
            this.$router.push({
                name: 'Projects'
            })

        }
    },
    computed: {},
}
</script>

<style scoped>
.projectTitleArea {
    border-bottom: 1px solid #d9d9d9;
}

.projectFileArea {
    border-right: 1px solid #d9d9d9;

}

.slidearealist-leave-active,
.slidearealist-enter-active {
    transition: .5s;
    transition-timing-function: ease-out;
    overflow: hidden;

}

.slidearealist-enter {
    transform: translate(10%, 0);
}

.slidearealist-leave-to {
    transform: translate(0%, 0);
}
</style>
